<template>
  <div>
    <a-alert :message="$t('bill.sharing_tip')" type="info" class="mb-2" />
    <page-list
      :list="list"
      :columns="columns"
      :group-actions="groupActions"
      :single-actions="singleActions"
      :showSearchbox="showSearchbox"
      :showGroupActions="showGroupActions"
      :export-data-options="exportDataOptions" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import * as R from 'ramda'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import { getBillResourceTypeLabel } from '@Bill/utils'
// import {
//   getBrandTableColumn,
// } from '@/utils/common/tableColumn'

export default {
  name: 'ProjectSharingPolicyList',
  components: {
  },
  mixins: [WindowsMixin, ListMixin],
  props: {
    resId: {
      type: String,
      require: true,
    },
    accountData: Object,
    id: String,
    getParams: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: 'SharingPolicyForCloudaccountSidepage',
        apiVersion: 'v1',
        resource: 'project_sharing_accounts',
        getParams: this.getParam,
        filterOptions: {
          sharing: {
            label: this.$t('table.title.name'),
            filter: true,
            jointFilter: true,
            formatter: val => {
              return `project_sharings.id(sharing_id).name.contains('${val}')`
            },
          },
        },
      }),
      groupActions: [
        {
          label: this.$t('common.create'),
          permission: 'project_sharings_create',
          action: () => {
            this.createDialog('BillSharingCreateDialog', {
              account_id: this.resId,
              provider: this.accountData.provider,
              data: this.accountData,
              onManager: this.onManager,
              // resource_type: this.billConfig.share_resource_type || 'origin_res_type',
              ok: () => {
                this.list.refresh()
              },
            })
          },
          meta: () => {
            return {
              buttonType: 'primary',
            }
          },
        },
        {
          label: this.$t('bill.immediate_share'),
          permission: 'bill_tasks_create',
          action: () => {
            this.createDialog('BillSharingShareDialog', {
              account_id: this.resId,
            })
          },
        },
      ],
      columns: [
        {
          title: this.$t('table.title.name'),
          field: 'name',
          formatter: ({ row }) => {
            return row.sharing || '-'
          },
        },
        {
          field: 'rules',
          title: this.$t('bill.sharing_policy'),
          slots: {
            default: ({ row }) => {
              if (!row.rules_detail?.length) return '-'
              // const data = row
              const columns = [
                {
                  field: 'match_source',
                  title: this.$t('bill.sharing_source'),
                  slots: {
                    default: ({ row }, h) => {
                      if (!row.match_source) {
                        return this.$t('bill.sharing_source.default')
                      } else if (row.match_source === 'projects') {
                        const ret = []
                        ret.push(<div>{this.$t('bill.sharing_source.projects')}</div>)
                        const { match_projects = [] } = row
                        const projects = match_projects.map(item => item.name).join(',')
                        if (projects) {
                          ret.push(<div>{`${this.$t('bill.sharing_source.projects')}: ${projects}`}</div>)
                        }
                        return ret
                      } else if (row.match_source === 'projects_of_account') {
                        return this.$t('bill.sharing_source.projects_of_account')
                      }
                    },
                  },
                },
                {
                  field: 'type',
                  title: this.$t('bill.resource_type_from'),
                  formatter: ({ row }) => {
                    const field = row.field
                    if (field === 'resource_type') {
                      return this.$t('bill.text_73')
                    }
                    if (field === 'origin_res_type') {
                      return this.$t('bill.sharing.origin_res_type')
                    }
                    if (field === 'product_detail_code') {
                      return this.$t('bill.sharing.product_detail_code')
                    }
                    return this.$t('bill.all_resources')
                  },
                },
                {
                  field: 'resource_type',
                  title: this.$t('bill.share_resource_type'),
                  slots: {
                    default: ({ row }) => {
                      if (row.field === '__any__') {
                        return this.$t('bill.all')
                      } else {
                        if (!row.values?.length) return this.$t('bill.all')
                        const ret = []
                        row.values.map(key => {
                          const name = row.field === 'resource_type' ? getBillResourceTypeLabel(key) : key
                          ret.push(<div>{name}</div>)
                        })
                        return ret
                      }
                    },
                  },
                },
                {
                  field: 'projects',
                  title: this.$t('bill.share_target_project'),
                  slots: {
                    default: ({ row }) => {
                      // 按项目标签分摊
                      if (row.target_project_tag_key) {
                        // return row.target_project_tag_key
                        const { target_project_tag_key = '', target_project_tag_value_percentage = {} } = row
                        const ret = [<div>{this.$t('bill.projects_with_tag')}</div>]
                        const keys = Object.keys(target_project_tag_value_percentage)
                        keys.map(key => {
                          ret.push(<div class='mr-1 mb-1' style='border:solid 1px #d9d9d9;background:#fafafa'>{target_project_tag_key.replace('user:', '').replace('ext:', '')}:{key}</div>)
                        })
                        return ret
                      } else if (row.target_project_ids_percentage) {
                        const { target_project_ids_percentage = {}, target_projects = [] } = row
                        const keys = Object.keys(target_project_ids_percentage)
                        const ret = []
                        keys.map(id => {
                          const t = target_projects.filter(item => item.id === id)
                          const name = t.length ? t[0].name : id
                          ret.push(<div class='mr-1 mb-1' style='border:solid 1px #d9d9d9;background:#fafafa'>{name}</div>)
                        })
                        return ret
                      } else if (row.share_target === 'projects_of_account') {
                        return this.$t('bill.sharing_source.projects_of_other_account')
                      } else if (row.share_target === 'other_projects_of_account') {
                        return this.$t('bill.sharing_source.other_projects_of_account')
                      } else {
                        const ret = []
                        const { target_projects = [] } = row
                        target_projects.map(project => {
                          ret.push(<div>{project.name}</div>)
                        })
                        return ret
                      }
                    },
                  },
                },
                {
                  field: 'rate',
                  title: this.$t('bill.share_rate'),
                  slots: {
                    default: ({ row }) => {
                      const { share_method } = row
                      if (row.target_project_tag_key) {
                        // return row.target_project_tag_key
                        const { target_project_tag_value_percentage = {} } = row
                        const ret = []
                        const keys = Object.keys(target_project_tag_value_percentage)
                        keys.map(key => {
                          ret.push(<div class='mr-1 mb-1' style='border:solid 1px #d9d9d9;background:#fafafa'>{key}:{target_project_tag_value_percentage[key] * 100 + '%'}</div>)
                        })
                        return ret
                      }
                      if (row.target_project_ids_percentage) {
                        const { target_project_ids_percentage = {}, target_projects = [] } = row
                        const keys = Object.keys(target_project_ids_percentage)
                        const ret = []
                        keys.map(id => {
                          const t = target_projects.filter(item => item.id === id)
                          const name = t.length ? t[0].name : id
                          ret.push(<div class='mr-1 mb-1' style='border:solid 1px #d9d9d9;background:#fafafa'>{name}:{(target_project_ids_percentage[id] || 0) * 100 + '%'}</div>)
                        })
                        return ret
                      }
                      if (share_method === 'even') {
                        return this.$t('bill.share_equally')
                      } else if (share_method === 'proportional') {
                        return this.$t('bill.share_proportional')
                      }

                      if (row.share_target === 'projects_of_account' || row.share_target === 'other_projects_of_account') {
                        return this.$t('bill.share_equally')
                      } else {
                        if (row.target_projects?.length > 1) {
                          return this.$t('bill.share_equally')
                        } else {
                          return '100%'
                        }
                      }
                    },
                  },
                  formatter: ({ row }) => {
                    const { share_method } = row
                    if (row.target_project_tag_key) {
                      // return row.target_project_tag_key
                      const { target_project_tag_key = '', target_project_tag_value_percentage = {} } = row
                      const ret = [<div>{this.$t('bill.projects_with_tag')}</div>]
                      const keys = Object.keys(target_project_tag_value_percentage)
                      keys.map(key => {
                        ret.push(<div class='mr-1 mb-1' style='border:solid 1px #d9d9d9;background:#fafafa'>{target_project_tag_key.replace('user:', '').replace('ext:', '')}:{key}</div>)
                      })
                      return ret
                    }
                    if (share_method === 'even') {
                      return this.$t('bill.share_equally')
                    } else if (share_method === 'proportional') {
                      return this.$t('bill.share_proportional')
                    }

                    if (row.share_target === 'projects_of_account' || row.share_target === 'other_projects_of_account') {
                      return this.$t('bill.share_equally')
                    } else {
                      if (row.target_projects?.length > 1) {
                        return this.$t('bill.share_equally')
                      } else {
                        return '100%'
                      }
                    }
                  },
                },
              ]
              return [<list-body-cell-popover text={this.$t('common_701', [row.rules_detail?.length || 0])} min-width="700px" >
                <vxe-grid
                  size="mini"
                  border
                  showOverflow={false}
                  row-config={{ isHover: true }}
                  column-config={{ resizable: false }}
                  data={ row.rules_detail || [] }
                  columns={ columns } />
              </list-body-cell-popover>]
            },
          },
          formatter: ({ row }) => {
            if (row.rules_detail) {
              const ret = []
              row.rules_detail.map(item => {
                let sourceStr = this.$t('bill.sharing_source') + ':'
                let typeStr = this.$t('bill.share_resource_type') + ':'
                let projectStr = this.$t('bill.share_target_project') + ':'
                let rateStr = this.$t('bill.share_rate') + ':'
                // 源项目类型
                if (!item.match_source) {
                  sourceStr += this.$t('bill.sharing_source.default')
                } else if (item.match_source === 'projects') {
                  sourceStr += this.$t('bill.sharing_source.projects')
                  const { match_projects = [] } = item
                  const projects = match_projects.map(item => item.name).join(',')
                  if (projects) {
                    sourceStr += `;${this.$t('bill.sharing_source.projects')}: ${projects}`
                  }
                } else if (item.match_source === 'projects_of_account') {
                  sourceStr += this.$t('bill.sharing_source.projects_of_account')
                }
                // 类型
                if (item.field === '__any__') {
                  typeStr += this.$t('bill.all_resources')
                } else {
                  if (item.field === 'resource_type') {
                    typeStr += `${this.$t('bill.text_73')}(${item.values?.length ? item.values.map(key => getBillResourceTypeLabel(key)).join(',') : this.$t('bill.all')})`
                  } else if (item.field === 'origin_res_type') {
                    typeStr += `${this.$t('bill.sharing.origin_res_type')}(${item.values?.length ? item.values.join(',') : this.$t('bill.all')})`
                  } else if (item.field === 'product_detail_code') {
                    typeStr += `${this.$t('bill.sharing.product_detail_code')}(${item.values?.length ? item.values.join(',') : this.$t('bill.all')})`
                  }
                }
                // 目标项目
                // 按项目标签分摊
                if (item.target_project_tag_key) {
                  const { target_project_tag_key = '', target_project_tag_value_percentage = {} } = item
                  const ret = []
                  const keys = Object.keys(target_project_tag_value_percentage)
                  keys.map(key => {
                    ret.push(`${target_project_tag_key.replace('user:', '').replace('ext:', '')}:${key}`)
                  })
                  projectStr += (this.$t('bill.projects_with_tag') + ':' + ret.join(','))
                } else if (item.share_target === 'projects_of_account') {
                  projectStr += this.$t('bill.sharing_source.projects_of_other_account')
                } else if (item.share_target === 'other_projects_of_account') {
                  projectStr += this.$t('bill.sharing_source.other_projects_of_account')
                } else {
                  item.target_projects.map((project, index) => {
                    projectStr += `${project.name}${index === 0 ? '' : ','}`
                  })
                }
                // 比例
                if (item.share_target === 'projects_of_account' || item.share_target === 'other_projects_of_account') {
                  rateStr += this.$t('bill.share_equally')
                } else {
                  if (item.target_projects?.length > 1) {
                    rateStr += this.$t('bill.share_equally')
                  } else {
                    rateStr += '100%'
                  }
                }
                ret.push(`${sourceStr};${typeStr};${projectStr};${rateStr}`)
              })
              return ret.join(' \n\t')
            }
            return ''
          },
        },
        {
          field: 'date',
          title: this.$t('bill.effective_start_time'),
          formatter: ({ row }) => {
            return row.date ? this.$moment(row.date + '').format('YYYY-MM') : '-'
          },
        },
      ],
      singleActions: [
        {
          label: this.$t('table.action.modify'),
          permission: 'project_sharings_update',
          action: (row) => {
            let resource_type = this.billConfig.share_resource_type || 'origin_res_type'
            const { rules_detail = [] } = row
            rules_detail.map(item => {
              if (item.field === 'resource_type' || item.field === 'origin_res_type') {
                resource_type = item.field
              }
            })
            this.createDialog('BillSharingCreateDialog', {
              type: 'update',
              account_id: this.resId,
              provider: this.accountData.provider,
              data: this.accountData,
              row,
              onManager: this.onManager,
              resource_type,
              ok: () => {
                this.list.refresh()
              },
            })
          },
        },
        {
          label: this.$t('table.action.clone'),
          permission: 'project_sharings_create',
          action: (row) => {
            let resource_type = this.billConfig.share_resource_type || 'origin_res_type'
            const { rules_detail = [] } = row
            rules_detail.map(item => {
              if (item.field === 'resource_type' || item.field === 'origin_res_type') {
                resource_type = item.field
              }
            })
            this.createDialog('BillSharingCreateDialog', {
              type: 'create',
              isClone: true,
              account_id: this.resId,
              provider: this.accountData.provider,
              data: this.accountData,
              row,
              onManager: this.onManager,
              resource_type,
              ok: () => {
                this.list.refresh()
              },
            })
          },
        },
        {
          label: this.$t('table.action.delete'),
          permission: 'project_sharings_delete',
          action: (row) => {
            this.createDialog('DeleteResDialog', {
              vm: this,
              data: [row],
              columns: this.columns,
              title: this.$t('table.action.delete'),
              name: this.$t('bill.bill_sharing_policy'),
              idKey: 'sharing_id',
              ok: async () => {
                try {
                  await new this.$Manager('project_sharings').batchDelete({
                    ids: [row.sharing_id],
                  })
                  this.list.refresh()
                } catch (err) {}
              },
            })
          },
        },
      ],
    }
  },
  computed: {
    ...mapState('common', {
      billConfig: state => state.bill.globalConfig,
    }),
    exportDataOptions () {
      const items = this.columns.map(item => {
        return {
          key: item.field,
          label: item.title,
          formatter: item.formatter,
        }
      })
      return {
        title: this.$t('bill.bill_sharing_policy'),
        downloadType: 'local',
        items,
      }
    },
  },
  created () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      this.list.fetchData()
    },
    getParam () {
      const getParams = (R.is(Function, this.getParams) ? this.getParams() : this.getParams)
      const ret = {
        details: false,
        account_id: this.resId,
        ...getParams,
      }
      return ret
    },
    handleOpenSidepage (row) {
      this.sidePageTriggerHandle(this, 'ProjectsharingSidePage', {
        id: row.id,
        resource: 'project_sharings',
        apiVersion: 'v1',
        getParams: this.getParams,
      }, {
        list: this.list,
        hiddenActions: this.hiddenActions,
      })
    },
  },
}
</script>
